import { of, combineLatest } from 'rxjs'
import { switchMap, tap, withLatestFrom, ignoreElements } from 'rxjs/operators'
import Actions from '../actions'
import { getPayload } from '../utils/rxUtils'
import { event, eventTypes } from '../consts/eventConsts'
import {
  formTrackingEventHitscope,
  pageViewEventPageScope,
  pageViewEventUserScope,
} from '../utils/eventUtils'
import LogRocket from 'logrocket'

const dataLayerPush = event => {
  window.preDataLayer = window.preDataLayer || []
  event.event = 'data.' + event.event
  window.preDataLayer.push(event)
}

const analyticsHandler = (
  type,
  event,
  element = null,
  data = null,
  error = null,
  userScope = null
) => {
  let dataLayerEvent = { event: event }
  let logrocketData = { ...data }
  if (type === eventTypes.formEvent || type === eventTypes.botEvent) {
    dataLayerEvent = {
      ...dataLayerEvent,
      ...formTrackingEventHitscope(element, data, error),
    }
    logrocketData = {
      ...logrocketData,
      ...formTrackingEventHitscope(element, data, error),
    }
    if (userScope) {
      dataLayerEvent = { ...dataLayerEvent, ...userScope }
    }
  } else if (type === eventTypes.pageViewEvent) {
    dataLayerEvent = {
      ...dataLayerEvent,
      ...pageViewEventPageScope(data),
      ...pageViewEventUserScope(data),
    }
    logrocketData = {
      ...logrocketData,
      ...pageViewEventPageScope(data),
      ...pageViewEventUserScope(data),
    }
  } else if (type === eventTypes.purchaseEvent) {
    dataLayerEvent = {
      ...dataLayerEvent,
      ...data,
    }
  } else if (type === eventTypes.click) {
    dataLayerEvent = {
      ...dataLayerEvent,
      ...data,
    }
  }
  dataLayerPush(dataLayerEvent)
  LogRocket.track(event, logrocketData)
}

export const initAnalytics = action$ =>
  action$.pipe(
    getPayload(Actions.APP_LAUNCHED),
    switchMap(() => of(Actions.createAction(Actions.ANALYTICS_INITIATED, {})))
  )

// Log Events:

const formatAnalyticMessage = eventName => {
  return eventName.toLowerCase()
}

export const genericAnalyticRecord = (action$, state$) => {
  return combineLatest([
    action$.pipe(getPayload(Actions.ANALYTICS_EVENT_FIRED)),
    action$.pipe(getPayload(Actions.ANALYTICS_INITIATED)),
  ]).pipe(
    withLatestFrom(state$),
    tap(([[{ type, eventName, element, data, error, userScope }], state]) => {
      analyticsHandler(
        type,
        formatAnalyticMessage(eventName),
        element,
        data,
        error,
        userScope
      )
    }),
    ignoreElements()
  )
}

const salesforceAnalyticsHandler = () => {
  window.embedded_svc.addEventHandler('onHelpButtonClick', function (data) {
    analyticsHandler(
      eventTypes.formEvent,
      formatAnalyticMessage(event.formEvent.submit),
      'onHelpButtonClick',
      data
    )
  })

  window.embedded_svc.addEventHandler('onChasitorMessage', function (data) {
    analyticsHandler(
      eventTypes.formEvent,
      formatAnalyticMessage(event.formEvent.submit),
      'onChasitorMessage',
      data
    )
  })

  window.embedded_svc.addEventHandler('onChatRequestSuccess', function (data) {
    analyticsHandler(
      eventTypes.formEvent,
      formatAnalyticMessage(event.formEvent.submit),
      'onChatRequestSuccess',
      data
    )
  })
}

export const salesforceAnalyticsInit = action$ => {
  return action$.pipe(getPayload(Actions.ANALYTICS_INITIATED)).pipe(
    tap(() => {
      salesforceAnalyticsHandler()
    }),
    ignoreElements()
  )
}
